






import { Component, Vue, Prop } from 'vue-property-decorator';
import googleMapIniter from '@/commons/gmap';
import store from '@/store';

@Component({
})
export default class GmapAutocomplete extends Vue {
    @Prop() private id!: string;
    @Prop() private name!: string;
    @Prop() private placeTypes!: string[];

    public mounted() {
        googleMapIniter().then((gmapApi) => {
            let el!: HTMLInputElement;
            const inputName = this.name;
            const autocompleteEls = document.getElementsByClassName('autocomplete-field');
            const autocompleteOpts = {
                types: this.placeTypes || ['address'],
                componentRestrictions: {country: store.state.options.country.default.toLowerCase()},
            };
            Array.prototype.forEach.call(autocompleteEls, (testElement: HTMLInputElement) => {
                const foundEls = testElement.querySelectorAll('[name=' + inputName + ']');
                if (foundEls.length === 1) {
                    el = foundEls[0] as HTMLInputElement;
                }
            });
            window.gmapAutocompleteElement[this.id] = el;
            window.gmapAutocomplete[this.id] = new gmapApi.maps.places.Autocomplete(el, autocompleteOpts);
            window.gmapAutocompleteListener[this.id] = window.gmapAutocomplete[this.id]
                .addListener('place_changed', () => {
                    const place = window.gmapAutocomplete[this.id].getPlace();
                    if (place) {
                        // console.log(place);
                        this.$emit('placeFound', place);
                    }
                });
        });
    }
}
